

<mat-card>
        <div class="button-wrapper">
            <div class="buttons" [ngClass]="{ 'todays-rates-mode': (isTodaysRatesMode$ | async), 'historical-rates-mode': !(isTodaysRatesMode$ | async) }">
                <button class="btn toggle-btn" [ngClass]="(isTodaysRatesMode$ | async) ? 'on' : 'off'" (click)="setPageMode('TodaysRates')">Current</button>
                <button class="btn toggle-btn" [ngClass]="(isHistoricalRatesMode$ | async) ? 'on' : 'off'" (click)="setPageMode('HistoricalRates')">Historic</button>
            </div>
        </div>
    
        <div [hidden]="!(isTodaysRatesMode$ | async)">
            <lgv-todays-rates></lgv-todays-rates>
        </div>
        <div [hidden]="!(isHistoricalRatesMode$ | async)">
            <lgv-mortgage-rate-history></lgv-mortgage-rate-history>
        </div>
</mat-card>


